import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UserNamesContext = createContext({ names: {}, resolveName: (v) => v });

const localpartToName = (email) => {
  const local = (email.split('@')[0] || '').trim();
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ') || email;
};

export const UserNamesProvider = ({ children }) => {
  const [names, setNames] = useState({});

  const { user } = useAuth();
  useEffect(() => {
    let mounted = true;
    if (user?.role !== 'admin') return undefined; // admin-only endpoint
    axios
      .get(`${API}/users/display-names`)
      .then((r) => { if (mounted) setNames(r.data || {}); })
      .catch(() => {});
    return () => { mounted = false; };
  }, [user?.role]);

  // Resolve any author/by stamp to a full name. Emails map to the person's name
  // (falls back to a title-cased localpart); non-email values are returned as-is.
  const resolveName = useCallback(
    (value) => {
      if (!value || typeof value !== 'string') return value || '';
      const v = value.trim();
      if (!v) return v;
      if (v.includes('@')) {
        return names[v.toLowerCase()] || localpartToName(v);
      }
      return v;
    },
    [names]
  );

  return (
    <UserNamesContext.Provider value={{ names, resolveName }}>
      {children}
    </UserNamesContext.Provider>
  );
};

export const useUserNames = () => useContext(UserNamesContext);
